import React from "react";
import { useLocation } from "react-router-dom";
import style from "css/template.module.css";

/**
 * Version : 1.0
 * 작성일자 : 2023-12-11
 * 작성자 : 권도훈
 * 설명 : 공통 템플릿 영역
 */
function Body({ children }) {
  //navigate
  const { pathname } = useLocation();
  const path = process.env.NODE_ENV === "production" ? "/riv" : "/";
  return (
    <div
      className={
        // pathname.split(path)[1] === "" || pathname.split(path)[1] === "/"
        //   ? style.body_landing
        //   : style.body
        style.body
      }
    >
      {children}
    </div>
  );
}

export default Body;
